<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Category from "@/models/category.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Category.getSchema(),
			};
		},
		methods: {
			openEntity(entity) {
				this.$router.push(`/categoria/${entity.id}`);
			},
			createEntity() {
				this.$router.push(`/categoria/novo`);
			},
			searchEntities(paginationParameters) {
				return Category.search(paginationParameters);
			},
		},
	}
</script>